export const SURVEY_TAG = "survey";
export const RESPONSE_TAG = "response";
export const SURVEY_QUESTION_TAG = "survey_question";


export const TagType = [
    SURVEY_TAG,
    RESPONSE_TAG,
    SURVEY_QUESTION_TAG
];